"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initUserInfo = exports.storeToken = exports.logout = exports.clearError = exports.reportError = exports.registerAccount = exports.requestLogin = exports.closeAuthModal = exports.openSignUpModal = exports.openLoginModal = void 0;

var _types = require("./types");

var openLoginModal = function openLoginModal() {
  return {
    type: _types.OPEN_LOGIN_MODAL
  };
};

exports.openLoginModal = openLoginModal;

var openSignUpModal = function openSignUpModal() {
  return {
    type: _types.OPEN_SIGNUP_MODAL
  };
};

exports.openSignUpModal = openSignUpModal;

var closeAuthModal = function closeAuthModal() {
  return {
    type: _types.CLOSE_LOGIN_MODAL
  };
};

exports.closeAuthModal = closeAuthModal;

var requestLogin = function requestLogin(credentials) {
  return {
    type: _types.REQUEST_LOGIN,
    credentials: credentials
  };
};

exports.requestLogin = requestLogin;

var registerAccount = function registerAccount(credentials) {
  return {
    type: _types.REGISTER_ACCOUNT,
    credentials: credentials
  };
};

exports.registerAccount = registerAccount;

var reportError = function reportError(error) {
  return {
    type: _types.STORE_ERROR,
    error: error
  };
};

exports.reportError = reportError;

var clearError = function clearError() {
  return {
    type: _types.CLEAR_ALL_ERRORS
  };
};

exports.clearError = clearError;

var logout = function logout() {
  return {
    type: _types.LOGOUT
  };
};

exports.logout = logout;

var storeToken = function storeToken(token, userRole, id) {
  return {
    type: _types.STORE_TOKEN,
    token: token,
    userRole: userRole,
    id: id
  };
};

exports.storeToken = storeToken;

var initUserInfo = function initUserInfo() {
  return {
    type: _types.INIT_USER_INFO
  };
};

exports.initUserInfo = initUserInfo;